var _path, _mask, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2498 8.28667V36C34.2498 37.7949 32.7947 39.25 30.9998 39.25H9C7.20507 39.25 5.75 37.7949 5.75 36V4C5.75 2.20508 7.20508 0.75 9 0.75H26.0445L34.2498 8.28667Z",
    stroke: "#DEDEDE",
    strokeWidth: 1.5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_4841_5859",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 1H33.5V9.5H26C25.4477 9.5 25 9.05229 25 8.5V1Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 1H33.5H25ZM33.5 11H26C24.6193 11 23.5 9.88071 23.5 8.5L26.5 8H33.5V11ZM26 11C24.6193 11 23.5 9.88071 23.5 8.5V1H26.5V8L26 11ZM33.5 1V9.5V1Z",
    fill: "#DEDEDE",
    mask: "url(#path-2-inside-1_4841_5859)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 20,
    width: 19,
    height: 12,
    rx: 2,
    fill: "#4956F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35582 28.271C8.10382 28.595 7.82482 28.823 7.51882 28.955C7.21282 29.081 6.90382 29.144 6.59182 29.144C6.09982 29.144 5.65582 29.06 5.25982 28.892C4.86982 28.718 4.53982 28.481 4.26982 28.181C3.99982 27.881 3.79282 27.53 3.64882 27.128C3.50482 26.72 3.43282 26.282 3.43282 25.814C3.43282 25.334 3.50482 24.89 3.64882 24.482C3.79282 24.068 3.99982 23.708 4.26982 23.402C4.53982 23.096 4.86982 22.856 5.25982 22.682C5.65582 22.508 6.09982 22.421 6.59182 22.421C6.92182 22.421 7.23982 22.472 7.54582 22.574C7.85782 22.67 8.13682 22.814 8.38282 23.006C8.63482 23.198 8.84182 23.435 9.00382 23.717C9.16582 23.999 9.26482 24.323 9.30082 24.689H7.95082C7.86682 24.329 7.70482 24.059 7.46482 23.879C7.22482 23.699 6.93382 23.609 6.59182 23.609C6.27382 23.609 6.00382 23.672 5.78182 23.798C5.55982 23.918 5.37982 24.083 5.24182 24.293C5.10382 24.497 5.00182 24.731 4.93582 24.995C4.87582 25.259 4.84582 25.532 4.84582 25.814C4.84582 26.084 4.87582 26.348 4.93582 26.606C5.00182 26.858 5.10382 27.086 5.24182 27.29C5.37982 27.494 5.55982 27.659 5.78182 27.785C6.00382 27.905 6.27382 27.965 6.59182 27.965C7.05982 27.965 7.41982 27.848 7.67182 27.614C7.92982 27.374 8.07982 27.029 8.12182 26.579H6.69982V25.526H9.39982V29H8.49982L8.35582 28.271ZM10.5409 22.574H11.9539V29H10.5409V22.574ZM13.1952 22.574H17.7132V23.762H14.6082V25.247H17.2992V26.345H14.6082V29H13.1952V22.574Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGif);
export default __webpack_public_path__ + "static/media/gif.e4f851dd8b20a7b5f56e7db468abe4ca.svg";
export { ForwardRef as ReactComponent };